<!-- <template>
    <div class="software-integrations-area bg-gradient-color">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="software-integrations-content white-color">
                       <span class="sub-title text-uppercase  ">#Agile Methodology</span>
                        <h2> CRM & AI-Driven Web Development</h2>
                        <p>Build CRM systems and web platforms that adapt to each user’s preferences. AI personalization ensures visitors see relevant content, while automation streamlines lead management, scoring, and customer support.</p>
                        <p><strong><i>Industries:</i></strong> B2B services, retail, real estate, healthcare, and more
                         Key Benefits: Enhanced engagement, automated workflows, higher lead conversion, scalable design</p>
                         <p><strong><i>Technologies:</i></strong> PHP, Laravel, React, Vue.js, MySQL, MongoDB, Dialogflow, Azure Cognitive Services</p>
                      
                        <router-link to="/contact" class="default-btn">Contact Us</router-link>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="software-integrations-list">
                        <img src="../../assets/images/shape/border.png" alt="border">
                        <ul>
                            <li data-aos="fade-down">
                                <img src="../../assets/images/software-integrations/atlassian.png" class="atlassian" alt="atlassian">
                            </li>
                            <li data-aos="fade-right">
                                <img src="../../assets/images/software-integrations/skype.png" class="skype" alt="skype">
                            </li>
                            <li data-aos="fade-up">
                                <img src="../../assets/images/software-integrations/gdrive.png" class="gdrive" alt="gdrive">
                            </li>
                            <li data-aos="fade-down">
                                <img src="../../assets/images/software-integrations/slack.png" class="slack" alt="slack">
                            </li>
                            <li data-aos="fade-up">
                                <img src="../../assets/images/software-integrations/jira.png" class="jira" alt="jira">
                            </li>
                            <li>
                                <img src="../../assets/images/software-integrations/frame.png" class="frame" alt="frame">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape8">
            <img src="../../assets/images/shape/shape7.png" alt="shape">
        </div>
    </div>
</template> -->

<script>
export default {
    name: 'SoftwareIntegrations',
    props: {
        data:Object
    },
    
}
</script> 